export default __webpack_public_path__ + "static/media/796.1d0edeb8.png";